module.exports = __webpack_public_path__ + "d26102f0b970569782e41b216ea5eab5.svg";